import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { LifeAreaSideNavigationItem } from 'shared/components/connected/life-area-side-navigation-item';

export const LifeAreasList: React.FC = () => {
  const { pathname } = useLocation();
  const lifeAreas = useSortedLocalizedLifeAreas({ activeOnly: true });

  return (
    <>
      {lifeAreas.map((lifeArea) => (
        <LifeAreaSideNavigationItem
          key={lifeArea.id}
          lifeArea={lifeArea}
          currentPath={pathname}
        />
      ))}
    </>
  );
};
